module.exports = __webpack_public_path__ + "static/img/strona_049.4846d810.jpg";